<template>
  <div ref="container" class="tw-relative">
    <a-button @click="isActive = !isActive" icon="solar:user-broken" intent="icon" icon-class="!tw-text-2xl" class="tw-rounded-lg"></a-button>


    <transition
      class="tw-duration-200"
      enter-from-class="tw-translate-y-[10px]  tw-opacity-0"
      leave-to-class="tw-translate-y-[10px]  tw-opacity-0"
    >
      <div v-if="isActive">
        <div
          :class="[$root.$i18n.locale == 'ar' ? 'tw-left-0' : 'tw-right-0']"
          class="tw-w-fit tw-min-w-[200px] tw-shadow-md tw-max-w-[250px] tw-overflow-hidden tw-absolute -tw-bottom-1 tw-translate-y-full tw-bg-white tw-rounded-lg tw-border tw-border-b-2"
        >
          <div class="tw-w-full tw-pb-3">
            <div class="tw-flex tw-gap-2 tw-p-2 tw-items-center tw-pb-2 tw-border-b tw-border-gray-100">
              <div class="tw-w-[45px] tw-text-2xl tw-overflow-hidden tw-aspect-square tw-bg-gray-100 tw-border-2 tw-border-solid tw-border-y-gray-200 tw-border-x-gray-200 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                <icon class="tw-text-gray-500  tw-text-8xl" icon="material-symbols-light:emoji-nature" />
                <!-- <img :src="$frontend('assets/images/avatars/avatar.png')" class="tw-w-full tw-aspect-square tw-h-full tw-object-cover" alt=""> -->
              </div>

              <div class="tw-py-1">
                <h2 class="tw-text-gray-600 tw-font-semibold tw-whitespace-nowrap tw-truncate tw-text-sm">{{ visibleName }}</h2>
                <h3 class="tw-font-semibold tw-whitespace-nowrap tw-truncate tw-text-xs tw-px-1 tw-w-fit tw-rounded-sm tw-mt-0.5 tw-bg-blue-100 tw-text-blue-500 tw-capitalize">{{ authStore.user.role }}</h3>
              </div>
            </div>

            <div class="tw-w-full tw-mt-3">
              <button @click="isActive = false" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                <icon class="tw-text-xl tw-text-gray-500" icon="solar:user-circle-bold-duotone" />
                <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.my-account') }}</span>
              </button>

              <button :disabled="isLogginOut" @click="handleLogout" 
              :class="[isLogginOut && '!tw-text-gray-300 !tw-bg-gray-50']"
              class="tw-flex tw-items-center tw-gap-2 tw-text-red-500 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                <icon class="tw-text-xl" :icon="isLogginOut ? 'line-md:loading-alt-loop' : 'solar:logout-3-bold-duotone'" />
                <span class="tw-text-sm tw-font-medium">{{ $t('buttons.logout') }}</span>
              </button>
            </div>
          </div>
      </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { onClickOutside } from "@vueuse/core";
import { formatFullName } from '@/utils/string'
import { useAuthStore } from "@/stores";
import { useRouter } from "vue-router";
import { logout } from '@/api/auth'

const isActive = ref(false);
const container = ref(null);
const authStore = useAuthStore();
const router = useRouter();
const isLogginOut = ref(false);

const visibleName = computed(() => formatFullName(authStore.user.name));

onClickOutside(container, () => (isActive.value = false));

const handleLogout = async () => {
  isLogginOut.value = true;
  
  try {
    // Call API logout
    await logout();
    
    // Clean up connections and clear auth state
    await authStore.logout();
    
    // Navigate to login
    router.push({ name: 'auth.login' });
  } catch (error) {
    console.error('Error during logout:', error);
    // Still navigate to login even if there's an error
    router.push({ name: 'auth.login' });
  } finally {
    isLogginOut.value = false;
  }
}
</script>

<style>
</style>